import { DispositionsFormType } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { IntegratedFormProvider } from '../../forms/integrated-form-provider';
import { FR_EVENT_DETAILS_TABS } from '../../fr-event-details-page/constants';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { UPDATE_DISPOSITION_DEFAULT_FORM_VALUES } from '../../dispositions/constants';
import { useDispositionQuery } from '../../dispositions/hooks/use-disposition-query';
import { useUpdateDispositionMutation } from '../../dispositions/hooks/use-update-disposition-mutation';

interface FrUnassignCurrentUserUnitContainerProps {
    children: React.ReactNode;
    eventId: number;
}

export function FrUnassignCurrentUserUnitContainer(props: FrUnassignCurrentUserUnitContainerProps) {
    const { children, eventId } = props;
    const unitAssignment = useUnitAssignment();
    const openFrEventDetails = useOpenFrEventDetails();
    const dispositionUnitForm = useForm<DispositionsFormType>({
        defaultValues: {
            ...UPDATE_DISPOSITION_DEFAULT_FORM_VALUES,
        },
    });

    const dispositionQuery = useDispositionQuery({ agencyEventId: eventId });

    const updateDispositionMutation = useUpdateDispositionMutation({
        actingTransitioner: 'FIRST_RESPONDER',
        unitIds: unitAssignment?.unitId ? [unitAssignment.unitId] : undefined,
        onMutationSuccess: () => {
            openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.NARRATIVE);
        },
    });

    return (
        <IntegratedFormProvider
            query={dispositionQuery}
            mutation={updateDispositionMutation}
            form={dispositionUnitForm}
        >
            {children}
        </IntegratedFormProvider>
    );
}
